$(function () {
  $("form").on("ajax:before", function (event) {
    $(".spinner").show();
    $(".ec-limit-buttons input").prop("disabled", true);
  });
});
